import _ from "lodash";
import {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useContext,
} from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import useFetch from "../../utils/useFetch";
import SectionTemplate from "../SectionTemplate";
import Button from "../../toolkit/ButtonV1";
import CircledNumber from "../CircledNumber";
import CircledPencilIcon from "../../icons/CircledPencilIcon";
import ErrorAlert from "../../toolkit/ErrorAlert";
// import QuestionnaireContent from "../Questionnaire/QuestionnaireContext";
import PaymentContext from "../Questionnaire/Payment/PaymentContext";
import saveData from "../../utils/saveData";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import FinalizeContext from "../Questionnaire/FinalizeContext";
import LocationContext from "../Questionnaire/Locations/LocationContext";
import SupportingDocuments from "../Questionnaire/SupportingDocuments/SupportingDocuments";
import ERIClientSelectionContext from "../Questionnaire/ERIClientSelectionContext";
import UserOrganizationContext from "../Questionnaire/UserOrganizationContext";
import SectionNote from "../Questionnaire/SectionNote";
import SectionHeaderFooter from "../Questionnaire/SectionHeaderFooter";
import { HolidayVillage, Hvac } from "@mui/icons-material";
import { getOtgType, getstatuses } from "../../utils/Token";
import EmptyComponent from "../../utils/EmptyComponent";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import PlusIcon from "../../icons/PlusIcon";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import QuizIcon from "@mui/icons-material/Quiz";
import edit from "../../icons/edit.svg";
import { useNavigate } from "react-router-dom";

import axios from "../../utils/fvAxios";
import ChecklistQuestionnaireContext from "./ChecklistQuestionnaireContext";
import ChecklistSubSectionDialog from "./dialogs/ChecklistSubSectionDialog";
import BaseURL from "../../utils/base-uri.json";

import { ChecklistContext } from "../../../src/store/checklist-context";
import Delayed from "../../utils/Delayed";

import { styled } from "@mui/material";
const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    background:  rgba(97, 97, 97, 0.92)!important;
    color:#fff !important
  }
     & .MuiTooltip-arrow: {
    color: rgba(97, 97, 97, 0.92)!important;
  }
`;
function getQuestionNavOptions({ id, text, status }, idx) {
  return {
    id,
    text,
    status,
    leadingComponent:
      id == 0 ? <EmptyComponent /> : <CircledNumber num={idx + 1} />,
  };
}
const params = new URLSearchParams(window.location.search);
const PQID = params.get("pqid");

function getComponent(name) {
  switch (name) {
    // case "":
    // case "ClientSign":
    // case "VendorSign":
    // case "BiddingReporting":
    // case "SubSectionReport":
    // case "ProductCategoriesReporting":
    // case "ProficiencyReporting":
    // case "ClaycoBiddingReporting":
    // case "YearWiseStats":
    //   return QuestionnaireContent;
    // case "SitePrequalification":
    // case "LocationApproval":
    //   return LocationContext;
    // case "SupportingDocument":
    //   return SupportingDocuments;
    // case "PrequalificationPayment":
    //   return PaymentContext;
    // case "PrequalificationFinalize":
    //   return FinalizeContext;
    // case "ERIClientSelection":
    //   return ERIClientSelectionContext;
    // case "UserDetailsForEP": //new one add here!
    // case "UserOrganization":
    //   return UserOrganizationContext;
    // case "SectionHeader":
    // case "SectionFooter":
    //   return SectionHeaderFooter;
    default:
      return ChecklistQuestionnaireContext;
  }
}

export default function ChecklistSubSectionlist({
  dataUrl,
  Secid,
  selected,
  SectionType,
  IsSectionCompleted,
  HeaderTitle,
  FooterTitle,
  HeaderContent,
  FooterContent,
  setNextSection,
  PqStatusID,
  VIEWMODE,
  PQCLIENTID,
  ClientTemplate,
  refreshSectionList,
  reorderSubSections,
  isParent,
  isChild,
  childSubSections,
  parentSubSections,
  fetchLatestSubSections: parentFetchLatestSubSections,
  setFetchLatestSubSections: setParentFetchLatestSubSections,
  currentSubSection,
  parentSubSectionId,
}) {
  const params = new URLSearchParams(window.location.search);
  const checklistContext = useContext(ChecklistContext);
  const templateId = params.get("t");
  const [resp, setResp] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [Refresh, setRefresh] = useState(true);

  // const {
  //   data: resp,
  //   loading,
  //   error,
  // } = useFetch(
  //   "Checklist/GetChecklistSubSections?sectionId=" +
  //     Secid +
  //     "&Refresh=" +
  //     Refresh
  // );

  useEffect(() => {
    if (isParent) {
      setLoading(true);
      axios
        .get("Checklist/GetChecklistSubSections?sectionId=" + Secid)
        .then((res) => {
          if (res?.data?.status == false) {
            setError(res?.data);
            console.error(res?.data);
            return;
          }
          setError(null);
          setResp(res.data);
        })
        .catch((err) => {
          console.error(err);
          setError(err);
        })  .finally(() => {
          setLoading(false); // Set loading state to false regardless of success or error
        });
  
    } else if (isChild) {
      setResp({ data: childSubSections });
      setLoading(false);
    }
  }, [Refresh]);

  useEffect(() => {
    if (
      checklistContext?.refreshSubSections &&
      checklistContext?.refreshSubSections === true
    ) {
      axios
        .get(`Checklist/GetChecklistSubSections?sectionId=${Secid}`) // Use template literals for cleaner string concatenation
        .then((res) => {
          if (res?.data?.status === true) {
            setResp({ data: childSubSections });
            checklistContext.setRefreshSubSections(false);
          }
          if (res?.data?.status === false) {
            // Use strict equality (===) for comparison
            setError(res?.data);
            console.error(res?.data);
          } else {
            setError(null);
            setResp(res.data);
          }
        })
        .catch((err) => {
          console.error(err);
          setError(err);
        })
        // .finally(() => {
        //   setLoading(false); // Set loading state to false regardless of success or error
        // });
      setAlreadySelectedTab();
    }
  }, [checklistContext?.refreshSubSections]);

  // TODO: We Add Extra Perameter  "Refresh"
  const subSectionTabsRef = useRef(null);
  const [subSectionId, setSubSectionId] = useState(selected);
  const [subSection, setSubSection] = useState();
  const [subSections, setSubSections] = useState([]);
  const [NextId, setNextId] = useState();
  const [subSectionsAPIList, setSubSectionsAPIList] = useState([]);
  const [refreshSubSection, setRefreshSubSection] = useState(false);
  const [subSectionNavProps, setSubSectionNavProps] = useState({
    options: subSections?.map(getQuestionNavOptions),
    // onChange: setSubSectionId,
    onChange: (subSectionId) => {
      setSubSectionId(null);
      setSubSectionId(subSectionId);
    },
    // onChange: (id) => setSubSectionId(String(id)),
    refFromParent: subSectionTabsRef,
  });
  const [disabledButtons, setDisabledButtons] = useState({
    prev: true,
    next: true,
  });
  const [scrollTabIntoView, setScrollTabIntoView] = useState(false);
  const [saveState, setSaveState] = useState({});
  const [showFormButtons, setShowFormButtons] = useState(false);
  const [modifiedData, setModifiedData] = useState({});
  const [reset, setReset] = useState(false);
  const [questionReset, setQuestionReset] = useState(false);
  const [skippedPayment, setskippedPayment] = useState(false);
  const [skippedPayment1, setskippedPayment1] = useState(false);
  const [skippedPayment2, setskippedPayment2] = useState(false);
  const [subSectionDialogOpen, setSubSectionDialogOpen] = useState(false);

  const [resetButtons, setResetButtons] = useState(true);
  const [ResetQuestions, setResetQuestions] = useState(false);
  const [fetchLatestSubSections, setFetchLatestSubSections] = useState(false);

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(
    !!Object.keys(modifiedData).length
  );

  useEffect(() => {
    setSubSection(subSections.find((s) => s.id === subSectionId));
  }, [subSectionId, refreshSubSection]);

  useEffect(() => {
    setSubSectionNavProps((prev) => ({
      ...prev,
      options: subSections?.map(getQuestionNavOptions),
    }));
    if (
      subSections
        .map((data) => data.id)
        .includes(checklistContext.subSectionIdGlobal) &&
      isParent &&
      checklistContext.subSectionIdGlobal > 0
    ) {
      setSubSectionId(checklistContext.subSectionIdGlobal);
    } else if (
      subSections
        .map((data) => data.id)
        .includes(checklistContext.childSubSectionIdGlobal) &&
      isChild
    ) {
      setSubSectionId(
        checklistContext?.childSubSectionIdGlobal > 0
          ? checklistContext?.childSubSectionIdGlobal
          : subSections?.[0]?.id
      );
    } else {
      setSubSectionId(subSections?.[0]?.id);
    }
    setRefreshSubSection(!refreshSubSection);
  }, [subSections]);

  useEffect(() => {
    setIsVisibleToggle(subSection?.isVisible);
  }, [subSection]);

  useEffect(() => {
    // console.log(currentSubSection, subSection?.childChecklistSubSections);
  }, [currentSubSection]);

  useEffect(() => {
    setResp({ data: childSubSections ?? [] });
  }, [childSubSections]);
  useEffect(() => {
    if (resp?.data) {
      resp?.data.forEach(
        (q) => (q.component = getComponent(q.subSectionTypeCondition))
      ); //Todo: Handle sub section based content

      setSubSection(null);
      var subsections = GetSubsectionsList(resp?.data);

      if (isParent)
        setSubSections(subsections.filter((x) => x.parentId == null));
      else setSubSections(subsections);
    }
  }, [resp]);

  function GetSubsectionsList(data) {
    var res = [];
    res.push(
      ...data.map((r) => ({
        id: r.checklistSubSectionId,
        text: r.subSectionName,
        status: r.isSubSectionCompleted === true ? "completed" : "pending",
        SubsectiontypeCondition: r.subSectionTypeCondition,
        isSubSectionCompleted: r.isSubSectionCompleted,
        component: r.component,
        subSectionNotes: r.sectionNotes,
        isHide: r.isHide,
        isVisible: r.isVisible,
        checklistQuestions: r.checklistQuestions,
        childChecklistSubSections: r.childChecklistSubSections,
        parentId: r.parentId,
      }))
    );
    res.length > 0 &&
      res.push({
        id: 0,
        text: "Add New +",
        status: "pending",
        SubsectiontypeCondition: "",
        isSubSectionCompleted: false,
        component: ChecklistQuestionnaireContext,
        subSectionNotes: "",
        isHide: false,
        isVisible: true,
        checklistQuestions: [],
        parentId: res[0].parentId,
      });

    return res;
  }

  useEffect(() => {
    const subSectionIds = (subSections || []).map((f) => f.id);
    const idx = subSectionIds.indexOf(subSection?.id);
    if (saveState.status === "inProgress") {
      setDisabledButtons({
        prev: true,
        next: true,
        cancel: true,
        save: true,
      });
    } else {
      setDisabledButtons({
        prev: idx <= 0 || hasUnsavedChanges,
        next: idx == subSectionIds.length - 1 || hasUnsavedChanges,
        cancel: !hasUnsavedChanges,
        save: !hasUnsavedChanges,
      });
    }
  }, [subSection, saveState, hasUnsavedChanges]);

  useEffect(() => {
    setHasUnsavedChanges(!!Object.keys(modifiedData).length);
  }, [modifiedData]);

  useLayoutEffect(() => {
    if (scrollTabIntoView) {
      const subSectionIds = (subSections || []).map((f) => f.id);
      const idx = subSectionIds.indexOf(subSection?.id);
      subSectionTabsRef.current?.children[idx]?.scrollIntoView();
      setScrollTabIntoView(false);
      // setReset(true);
    }
  }, [subSection, scrollTabIntoView]);

  function hideCompleteAndContinue(type) {
    let subsections = [
      "SitePrequalification",
      "LocationApproval",
      "PrequalificationFinalize",
      "PrequalificationPayment",
      "SupportingDocument",
      "ERIClientSelection",
      "UserDetailsForEP",
      "UserOrganization",
    ];
    if (!type) {
      type = "";
    }
    return subsections.indexOf(type) != -1;
  }

  function setPrevActive() {
    const cur = subSections.find((f) => f.id === subSection.id);
    const prev = subSections[subSections.indexOf(cur) - 1];
    if (prev) {
      setScrollTabIntoView(true);
      setSubSectionId(prev.id);
    }
  }

  function setNextActive() {
    const cur = subSections.find((f) => f.id === subSection.id);
    const next = subSections[subSections.indexOf(cur) + 1];
    setSubSectionId(null);
    if (next) {
      setScrollTabIntoView(true);
      setSubSectionId(next.id);
    } else {
      setNextSection();
    }
  }
  // const [required, setRequired] = useState();
  const [validate, setValidate] = useState();
  const [TotPay, setTotPay] = useState("");
  const [Paymentdone, setTpaymentdone] = useState({});
  // const [Val, setVal] = useState(true);

  const ValidationsErrors = (value) => {
    setValidate(value);
  };
  // const Validate = (value) => {
  //   setRequired(value);
  //   console.log(value);
  // }
  const navigate = useNavigate();
  const HandlePayment = (val) => {
    setTpaymentdone(val);
  };
  const HandlePay = (val) => {
    setTotPay(val);
  };

  const SkipPay = (val) => {
    setskippedPayment(val);
  };
  const SkipPay1 = (val) => {
    setskippedPayment1(val);
  };
  const SkipPay2 = (val) => {
    setskippedPayment2(val);
  };
  const [Triggersitch, setTriggerSwitch] = useState();
  const Triger = (val) => {
    setTriggerSwitch(val);
  };
  const Footerid = subSections?.length - 1;
  const handleDialogClose = (isSavedSuccessfuly) => {
    setSubSectionDialogOpen(false);
    if (isSavedSuccessfuly === true) {
      if (isParent) {
        setRefresh(!Refresh);
        setAlreadySelectedTab();
      } else {
        checklistContext.setRefreshSubSections(true);
      }
    } else setSubSectionId(subSectionId == 0 ? subSections?.[0]?.id: subSectionId);
  };

  const addOrUpdateSubSection = (id) => {
    if (id > 0) {
      setSubSectionDialogOpen(true);
    } else setSubSectionId(0);
  };

  useEffect(() => {
    if (subSectionId == 0) {
      setSubSectionDialogOpen(true);
    }
  }, [subSectionId]);

  // useEffect(() => {
  //   console.log("fetchLatestSubSections", fetchLatestSubSections);
  //   if (isParent) {
  //     setRefresh(!Refresh);
  //   }
  // }, [fetchLatestSubSections]);

  // useEffect(() => {
  //   if (isParent) {
  //     setRefresh(!Refresh);
  //   }
  // }, [parentFetchLatestSubSections]);

  const [isVisibleToggle, setIsVisibleToggle] = useState(subSection?.isVisible);

  const switchToggleHandler = async (sectionId) => {
    setAlreadySelectedTab();
    let _section = {
      ChecklistSubSectionId: sectionId,
      IsVisible: !isVisibleToggle,
    };

    const response = await axios.post(
      BaseURL.templateTool.UpdateChecklistSubSectionVisibility,
      _section
    );

    if (response.data?.responseCode >= 0) {
      setIsVisibleToggle((prev) => !prev);
      if (isParent) refreshSectionList();
      else checklistContext.setRefreshSubSections(true);
    } else if (response.data?.responseCode == -100) {
      console.error(response.data?.responseMessage, false);
    } else if (response.data?.responseCode == -200) {
      console.error(response.data);
    } else console.error(response.data);
  };

  const setAlreadySelectedTab = () => {
    if (isParent) checklistContext.setSubSectionIdGlobal(subSectionId);
    if (isChild) checklistContext.setChildSubSectionIdGlobal(subSectionId);
  };

  const handleReorderSubSections = () => {
    setAlreadySelectedTab();
    reorderSubSections(subSections.filter((value) => value.id > 0));
  };
  return (
    <>
      <div className="pt-2">
        <div className="d-flex justify-content-between my-0">
          {subSections?.length > 0 && (
            <Button
              sx={{ minWidth: "130px" }}
              role="secondary"
              size="large"
              label="Re-Arrange"
              onClick={handleReorderSubSections}
            />
          )}
          <Button
            role="primary"
            size="default"
            label={`${isParent ? "Add Sub Section" : "Add Child Sub Section"}`}
            className="ms-auto"
            onClick={() => addOrUpdateSubSection(0)}
            trailingComponent={<PlusIcon />}
          />
        </div>
      </div>
      {subSectionDialogOpen && (
        <ChecklistSubSectionDialog
          setEditDialogOpen={setSubSectionDialogOpen}
          handleDialogClose={handleDialogClose}
          checklistSectionId={Secid}
          checklistSubSectionId={subSectionId}
          currentSubSectionCount={subSections?.length ?? 0}
          subSections={parentSubSections ?? []}
          parentSubSectionId={parentSubSectionId}
          isParent={isParent}
          isChild={isChild}
        />
      )}
      {loading ? (
        <div style={{ height: "850px" }}>
                <Box className="loading-spinner">
         <Box>
           <CircularProgress />
         </Box>
      
           <Box>
             <Typography variant="subtitle1">loading...</Typography>
           </Box>
     
       </Box>
        </div>
      ) : error ? (
        <ErrorAlert severity="error" message={error} />
      ) : (
        <SectionTemplate
          className="questionnaire-template"
          modifiedData={modifiedData}
          navProps={{
            ...subSectionNavProps,
            selected: subSectionId,
          }}
          NextId={NextId}
        >
          {/* <SectionNote classes={"p-3"} section={subSection?.subSectionNotes} /> */}

          <Box
            className="questionnaire-content p-2"
            sx={{
              backgroundColor: "#fff",
              marginbottom: "20px",
            }}
          >
            {subSection?.id > 0 && (
              <div className="p-3 d-flex my-0 justify-content-between pe-5 align-items-center">
                <Box>
                  <Typography style={{ fontWeight: "bold" }} className="mx-2">
                    {subSection?.text}
                  </Typography>
                  <Typography className="mx-2 text-break">
                    {subSection?.subSectionNotes && (
                      <span>({subSection.subSectionNotes})</span>
                    )}
                  </Typography>
                </Box>
                <div className="d-flex">
                  <Box width={"50px"}>
                    <Tooltip title="Edit">
                      <Typography className="mx-2">
                        <IconButton
                          aria-label="edit"
                          onClick={() => addOrUpdateSubSection(subSectionId)}
                        >
                          <img src={edit} alt="edit icon" />
                        </IconButton>
                      </Typography>
                    </Tooltip>
                  </Box>
                  <Box width={"50px"}>
                    <Tooltip
                      title={`${subSection?.isVisible ? "Hide" : "Show"}`}
                    >
                      <Typography className="mx-2">
                        <IconButton
                          aria-label="Visibility"
                          onClick={switchToggleHandler.bind(
                            null,
                            subSection?.id
                          )}
                        >
                          {isVisibleToggle ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility color="disabled" />
                          )}
                        </IconButton>
                      </Typography>
                    </Tooltip>
                  </Box>
                  <Box width={"50px"}>
                    <Tooltip title="Questions">
                      <Typography className="mx-2">
                        <IconButton
                          aria-label="Questions"
                          onClick={() =>
                            navigate(
                              "/CheckListDetails?c=" +
                                subSection.id +
                                "&tab=Question&t=" +
                                templateId
                            )
                          }
                        >
                          <QuizIcon />
                        </IconButton>
                      </Typography>
                    </Tooltip>
                  </Box>
                </div>{" "}
              </div>
            )}
          </Box>

          {subSection?.isVisible ? (
            // <subSection.component
            <div className="border p-2">
              <ChecklistQuestionnaireContext
                dataUrl={`${dataUrl}/${subSection.id}`}
                setShowFormButtons={setShowFormButtons}
                reset={reset}
                resetButtons={resetButtons}
                hasUnsavedChanges={hasUnsavedChanges}
                setReset={setReset}
                Secid={Secid}
                SubId={subSection?.id}
                IsSubSectionCompleted={subSection?.isSubSectionCompleted}
                SectionType={SectionType}
                SubSectionTypeCondition={subSection?.SubsectiontypeCondition}
                setModifiedData={setModifiedData}
                Validate={ValidationsErrors}
                // Required={Validate}
                RESETQUESTIONS={ResetQuestions}
                title={subSection?.title}
                content={subSection?.content}
                PAY={HandlePay}
                Skippedpayment={HandlePayment}
                SKIP={SkipPay}
                SKIP1={SkipPay1}
                SKIP2={SkipPay2}
                Skipped={skippedPayment}
                SubSectionName={subSection?.text}
                Triger={Triger}
                VIEWMODE={VIEWMODE}
                QuestionReset={questionReset}
                PQCLIENTID={PQCLIENTID}
                ClientTemplate={ClientTemplate}
                subSections={resp?.data}
              />
              {isParent && (
                <div className="border-top">
                  <ChecklistSubSectionlist
                    isChild={true}
                    Secid={Secid}
                    currentSubSection={subSection}
                    fetchLatestSubSections={fetchLatestSubSections}
                    setFetchLatestSubSections={setFetchLatestSubSections}
                    childSubSections={subSection.childChecklistSubSections}
                    parentSubSections={subSections}
                    parentSubSectionId={subSection.id}
                    reorderSubSections={reorderSubSections}
                  />
                </div>
              )}
            </div>
          ) : subSection ? (
            <Delayed waitBeforeShow={200}>
            <div
              className="rounded p-3 px-4 border d-block text-align-center"
              style={{ height: "400px" }}
            >
              <div>
                <h3>{subSection?.text} is Hidden</h3>
                <p className="mb-2">
                  Change Visibility using <Visibility color="disabled" /> icon
                </p>
              </div>
            </div>
            </Delayed>
          ) : (
            <div style={{ height: "400px" }}>
              <Delayed waitBeforeShow={2000}>
                <ErrorAlert severity="warning" message="Nothing to show!" />
              </Delayed>
            </div>
          )}
        </SectionTemplate>
      )}
    </>
  );
}
